import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getAvailableMenuItems } from "api/requests/getAvailableMenuItems";
import { MenuItem } from "custom-types/MenuItem";
import { Strain } from "custom-types/Strain";
import { getCoordinates } from "redux/selectors/location";

type StrainsWithAvailability = {
  name: string;
  hasMenuItems: boolean;
};

type Props = {
  strainsWithMenuItemAvailability: StrainsWithAvailability[];
};

const useStrainsWithMenuItemAvailability = (strains: Strain[]): Props => {
  const [strainsWithMenuItemAvailability, setStrainsWithMenuItemAvailability] =
    useState<StrainsWithAvailability[]>([]);

  const coordinates = useSelector(getCoordinates);

  useEffect(() => {
    if (strains?.length) {
      const strainNames = strains.map((strain) => strain.name);

      getAvailableMenuItems(coordinates, strainNames).then((menuItems) => {
        const strainsWithAvailability = strains?.map((strain) => {
          const hasMenuItems = !!menuItems.filter(
            (menuItem: MenuItem) => menuItem.name === strain.name
          )?.[0]?.menuItemCategories?.length;

          return { hasMenuItems, name: strain.name };
        });

        setStrainsWithMenuItemAvailability(strainsWithAvailability);
      });
    }
  }, [strains]);

  return { strainsWithMenuItemAvailability };
};

export default useStrainsWithMenuItemAvailability;
